export default __webpack_public_path__ + "static/media/Settings.3ef6389e.png";